export var openNewTab = function (url) {
    var newTabWindow = window.open(url, '_blank');
    if (newTabWindow != null) {
        newTabWindow.focus();
    }
};
